import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from 'utilities/common';
import cn from 'classnames';
import { waFormat } from 'utilities/common';

const manifestType = {
  last_mile: 'Last Mile',
  pickup: 'First Mile',
  console: 'Mid Mile',
  forwarder: 'Forward',
  return: 'Return',
};

const ManifestCard = ({ data, keys, active, onClick, privilege }) => {
  const Driver = ({ data }) => {
    if (!data) return null;

    const getDriver = (data) => {
      return data?.driver
        ? `${data?.driver?.name} (${waFormat(data?.driver?.phone)})`
        : '-';
    };

    return (
      <div className="col-12">
        <small className="info text-uppercase">{getDriver(data)}</small>
      </div>
    );
  };
  return (
    <div
      className={cn(
        'border-bottom row justify-content-center align-items-center cursor-pointer',
        active ? 'bg-primary-lt' : ''
      )}
      onClick={() => onClick(data?.id)}
    >
      <div className="col-2">
        <h3 className="text-center">{keys + 1}</h3>
      </div>
      <div className="col-10 table-col">
        <div className="row py-2">
          <div className="col-9">
            <small className="info text-uppercase">
              {formatDate(data?.schedule_at, 'DD/MM/YYYY')}
            </small>
            <div className="fs-8 fw-bold text-uppercase">
              {manifestType[data?.type]}
            </div>
            <small className="info text-uppercase">{data?.code}</small>
          </div>
          <div className="col-3">
            {data?.legs_count && (
              <div className="fs-6 pt-3 pe-3 text-center fw-bold text-uppercase">
                {data?.legs_count?.completed}/{data?.legs_count?.total}
              </div>
            )}
          </div>

          <Driver data={data?.moda?.land_freight} />
        </div>
        <div className="row border-top py-2">
          <div className="col-5">
            <span className={`badge status-${data?.status}-lt`}>
              {data?.status?.replace('_', ' ')?.replace('new', 'Draft')}
            </span>
          </div>
          <div className="col-7">
            <div className="p-0 pe-2 d-flex flex-row-reverse gap-2">
              <Link to={`/manifest/${data?.id}`} className="btn btn-xs">
                Detail
              </Link>
              {data?.status === 'new' && privilege && (
                <Link
                  to={`/manifest/${data?.id}/update`}
                  className="btn btn-xs"
                >
                  Edit
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManifestCard;
